//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  watch: {
    currentTime(val) {
      if (!this.isScrubbing) {
        this.scrubberInput = val;
      }
    },
    scrubberInput(val) {
      if (this.isScrubbing) {
        this.$emit("scrubbing", this.scrubberInput);
      }
    },
    fullscreen(newVal) {
      newVal ? this.$emit("fullscreen") : this.$emit("closeFullscreen");
    },
  },
  computed: {
    volumeIcon() {
      if (this.$store.state.playerIsMuted) {
        return "volume_off";
      } else {
        return "volume_up";
      }
    },
    currentTimeInMMSS() {
      var timeSrc = this.isScrubbing ? this.scrubberInput : this.currentTime;
      var minutes = Math.floor(timeSrc / 60);
      var seconds = Math.floor(timeSrc % 60);
      var output =
        seconds % 60 < 10 ? `${minutes}:0${seconds}` : `${minutes}:${seconds}`;
      return output;
    },
    durationInMMSS() {
      if (this.$store.state.duration) {
        var mins = Math.floor(this.$store.state.duration / 60);
        var secs =
          this.$store.state.duration % 60 < 10
            ? "0" + (this.$store.state.duration % 60)
            : this.$store.state.duration % 60;
        return `${mins}:${secs}`;
      } else return "0:00";
    },
  },
  data() {
    return {
      scrubberInput: 0,
      isScrubbing: false,
      fullscreen: false,
    };
  },
  props: {
    currentTime: {
      default: 0,
    },
  },
};
